// router.js
import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router';
import HomePage from "./views/home/homePage.vue";
import { getUrlLink } from './api/index.js';

// 定义路由
export const routes = [
  {
    path: '/', component: HomePage,
    hidden:false,
    enIsShow:true,
    meta: {
      title: '首页',
      i18n: 'home'
    }
  },
  {
    path: '/company', component: () => import('./views/company/companyPage.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '公司简介',
      i18n: 'company'
    }
  },
  {
    path: '/product', component: () => import('./views/product/productSystem.vue'), 
    hidden:false,
    enIsShow:true,
    meta: {
      title: '产品介绍',
      i18n: 'product'
    }
  },
  {
    path: '/productAcs', component: () => import('./views/product/productAcs.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '产品介绍-门禁系统',
      i18n: 'product'
    }
  },
  {
    path: '/productApplet', component: () => import('./views/product/productApplet.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '产品介绍-e停宝',
      i18n: 'product'
    }
  },
  {
    path: '/productCharge', component: () => import('./views/product/productCharge.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '产品介绍-智能充电',
      i18n: 'product'
    }
  },
  {
    path: '/productClose', component: () => import('./views/product/productClose.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '产品介绍-智能充电',
      i18n: 'product'
    },
  },
  {
    path: '/productChargeHw', component: () => import('./views/product/productChargeHw.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '产品介绍-智能充电硬件产品',
      i18n: 'product'
    }
  },
  {
    path: '/information', component: () => import('./views/information/informationPage.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '资料下载',
      i18n: 'information'
    }
  },
  {
    path: '/platform', component: () => import('./views/platform/platformPage.vue'), 
    hidden:false,
    enIsShow:true,
    meta: {
      title: '解决方案',
      i18n: 'platform'
    }
  },
  {
    path: '/platformCloud', component: () => import('./views/platform/platformCloud.vue'), 
    hidden:true,
    enIsShow:true,
    meta: {
      title: '解决方案',
      i18n: 'platform'
    }
  },
  {
    path: '/cases', component: () => import('./views/cases/casesPage.vue'), 
    hidden:false,
    enIsShow:true,
    meta: {
      title: '成功案例',
      i18n: 'cases'
    }
  },
  {
    path: '/cases-detail', component: () => import('./views/cases/casesDetail.vue'), 
    hidden:true,
    enIsShow:false,
    meta: {
      title: '成功案例',
      i18n: 'cases'
    }
  },
  {
    path: '/news', component: () => import('./views/news/newsPage.vue'),
    hidden:false,
    enIsShow:false,
     meta: {
      title: '新闻资讯',
      i18n: 'news'
    }
  },
  {
    path: '/news-detail', component: () => import('./views/news/newsDetail.vue'),
    hidden:true,
    enIsShow:true,
     meta: {
      title: '咨询详情',
      i18n: 'news'
    }
  },
  {
    path: '/service', component: () => import('./views/service/servicePage.vue'),
    hidden:false,
    enIsShow:true,
    meta: {
      title: '关于我们',
      i18n: 'service'
    }
  },
  { path: '/applet', component: HomePage,
    hidden:true,
    enIsShow:true,
   },
  { path: '/*', redirect: '/', hidden: true, },
];

// 创建router实例
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
});

export default router;
